const ar = {
  nav: { about: "من نحن", services: "الخدمات", logistics: "اللوجستيات", clients: "العملاء", news: "الأخبار", contact: "اتصل بنا", cta: "اطلب استشارة", menu: "القائمة", close: "إغلاق" },
  global: {
    eyebrow: "العالم في حركة",
    title: "من الساحل إلى _العواصم الكبرى_.",
    intro: "أشخاص ينجزون الأعمال وبضائع في الطريق: هذا هو العالم الذي نعمل فيه كل يوم.",
    capitals: "العواصم الكبرى",
    deals: "أشخاص وأعمال",
    base: "قاعدتي: الساحل",
    ops: "بضائع في الطريق",
    timezones: "المناطق الزمنية",
    newsTicker: "أخبار العالم · محدّثة دائمًا · اقرأ في قسم أخبار وأسواق بالأسفل",
  },
  news: {
    eyebrow: "06 — أخبار وأسواق",
    title: "عالم النقل، _بوقت حقيقي_.",
    intro: "عناوين محدّثة تلقائياً من أهم بوابات اللوجستيات الدولية.",
    read: "اقرأ",
    updated: "محدّث",
  },
  hero: {
    eyebrow: "استشارات أعمال · استيراد وتصدير · لوجستيات",
    lines: ["نُقدّم", "الشركات", "_إلى ما بعد_ الحدود."],
    sub: "نرافق الشركات في الاستيراد والتصدير، وإجراءات الوثائق، ودخول الأسواق الجديدة، واللوجستيات الدولية: من أول تواصل إلى التسليم النهائي.",
    cta: "لنتحدث عن مشروعك",
    cta2: "تصفح الخدمات",
    scroll: "مرّر",
    tags: ["بحر", "جو", "بر", "إكسبريس"],
    frame: "طرق عالمية، ومرجع واحد",
  },
  marquee: ["استيراد · تصدير", "إجراءات الوثائق", "درجة حرارة مراقبة", "بضائع خطرة DGR", "نقل بحري", "شحن جوي", "نقل بري", "تخزين وتغليف", "تطوير الأسواق"],
  about: {
    eyebrow: "01 — من نحن",
    title: "مستشار واحد، شبكة واحدة، _منهج واحد_ للنمو في الخارج.",
    body1: "تأسست MF Logistics Consulting Group لتكون مرجعاً واحداً للشركات عندما تقرر البيع أو الشراء أو الإنتاج خارج الحدود الوطنية.",
    body2: "نجمع بين الخبرة في الوثائق، ومعرفة الأسواق، والتشغيل اللوجستي، لتحويل فكرة التوسع إلى تدفق حقيقي من البضائع والعقود والعلاقات.",
    founderRole: "المؤسِّسة والرئيسة التنفيذية",
    founderLine: "خبرة دولية طويلة في أوروبا وحول العالم: أرافق الشركات عبر الحدود، بعناية ومنهجية.",
    doorCaption: "بابي مفتوح دائماً",
    pillars: [
      { t: "رؤية شاملة", d: "استراتيجية تجارية ووثائق ونقل كمشروع واحد متكامل." },
      { t: "تنفيذ ميداني", d: "نتابع كل شحنة وكل ملف حتى الإغلاق." },
      { t: "شبكة علاقات", d: "شركاء وموردون ومشترون مختارون بعناية في أسواق الوجهة." },
    ],
  },
  services: {
    eyebrow: "02 — الخدمات",
    title: "استشارة على المقاس، _من الورق_ إلى الحاوية.",
    intro: "كل شركة مختلفة: نصمم المسار الأنسب لشركتك.",
    items: [
      { t: "الاستيراد والتصدير", d: "تخطيط التدفقات وشروط الإنكوترمز والموردين والشركاء اللوجستيين للشراء والبيع في الخارج بأمان." },
      { t: "إجراءات الوثائق", d: "الجمارك وشهادات المنشأ ووثائق النقل والامتثال التنظيمي، تُدار بدقة." },
      { t: "إدخال المنتجات إلى السوق", d: "تحليل السوق المستهدف وشروط الدخول واستراتيجية الإطلاق لمنتجاتك." },
      { t: "التطوير في الأسواق الخارجية", d: "خطط التدويل والنمو التجاري في بلدان وقنوات جديدة." },
      { t: "تطوير العلاقات", d: "البحث عن المشترين والموزعين والشركاء في السوق المستهدف واختيارهم." },
      { t: "طلبات الشراء من الخارج", d: "البحث عن عملاء دوليين وإدارة طلبات الشراء، من أول تواصل حتى تأكيد الطلب." },
      { t: "استشارات الأعمال", d: "دعم في التنظيم والعمليات وأي حاجة أخرى تخص نشاطك التجاري." },
    ],
  },
  logistics: {
    eyebrow: "03 — اللوجستيات",
    title: "أي بضاعة، _أي_ طريق.",
    intro: "ننظم شحنات كاملة لكل نوع من البضائع ولكل وسيلة نقل، مع التخزين والتغليف.",
    modesTitle: "وسائل النقل",
    modesDesc: "نجمع بين البحر والجو والبر والإكسبريس لنحقق التوازن الصحيح بين الوقت والتكلفة والأمان.",
    modes: ["بحر", "جو", "بر", "إكسبريس"],
    goodsTitle: "أنواع البضائع",
    goods: [
      { t: "حرارة عادية — بضائع عامة", d: "بضائع عامة وشحنات مجمعة وكاملة." },
      { t: "حرارة مراقبة", d: "سلسلة تبريد ونطاقات حرارية مخصصة." },
      { t: "بضائع خطرة DGR", d: "إدارة وثائقية وتشغيلية وفق ADR / IMDG / IATA." },
    ],
    subsLabel: "فئات الشحن الفرعية",
    subs: ["أغذية وسريعة التلف (حتى المجمدة)", "صيدلاني", "آلات ومعدات", "بضائع فاخرة", "ملابس", "مستحضرات تجميل", "…والمزيد"],
    insurance: { t: "تأمين البضائع", d: "حماية كاملة لشحنتك في كل مرحلة." },
    docsPermits: { t: "الوثائق والتصاريح", d: "التسجيلات والشهادات الصحية وتصاريح الدخول وكل معاملة." },
    palletControl: { t: "التنميط والتفتيش", d: "تخزين وتنميط على منصات وفحص البضائع في المستودع." },
    warehousing: { t: "التخزين", d: "تخزين وإدارة المخزون والتوزيع." },
    packaging: { t: "التغليف", d: "تغليف مناسب للبضاعة ولوسيلة النقل وللأنظمة." },
    customs: { t: "الوثائق والجمارك", d: "من بوليصة الشحن إلى الشهادة: كل ورقة في مكانها." },
  },
  newsletter: {
    eyebrow: "النشرة البريدية",
    titleAccent: "ابقَ مُطلِعًا",
    title: " على العالم.",
    sub: "كل شهر: المسارات والأسواق ونصائح عملية للبيع والشراء عبر الحدود. بدون إزعاج.",
    placeholder: "بريدك الإلكتروني",
    cta: "اشترك",
    sending: "جارٍ الإرسال…",
    ok: "تم تأكيد الاشتراك! ستصلك أخبارنا.",
    already: "أنت مشترك بالفعل في النشرة.",
    error: "حدث خطأ. حاول مرة أخرى.",
    privacy: "بالاشتراك أنت توافق على تلقي رسائلنا. بدون إزعاج: يمكنك إلغاء الاشتراك في أي وقت.",
  },
  clients: {
    eyebrow: "04 — العملاء",
    title: "شركات اختارت _خدماتنا_.",
    intro: "بعض الشركات التي رافقناها في الأسواق الدولية.",
    consTitle: "من خلال _الاستشارات_.",
    impTitle: "من خلال _الاستيراد والتصدير_.",
    placeholder: "[شعار العميل]",
    visit: "زيارة",
  },
  contact: {
    eyebrow: "05 — اتصل بنا",
    title: "أخبرنا _إلى أين_ تريد الوصول.",
    intro: "اكتب لنا: سنتواصل معك لرسم أفضل طريق معاً.",
    fields: { name: "الاسم الكامل", company: "الشركة", email: "البريد الإلكتروني", phone: "الهاتف", service: "ما الذي تحتاجه؟", message: "الرسالة" },
    servicePick: "اختر خدمة",
    logisticsOption: "الشحن واللوجستيات",
    submit: "إرسال الطلب",
    sending: "جارٍ الإرسال…",
    success: "شكراً! استلمنا طلبك وسنتواصل معك قريباً.",
    error: "فشل الإرسال. تحقق من الحقول وحاول مجدداً.",
    direct: "تواصل مباشر",
    emailLabel: "البريد الإلكتروني",
    phoneLabel: "الهاتف",
    vatLabel: "الرقم الضريبي",
    addressLabel: "المقر",
  },
  footer: { tagline: "استشارات أعمال، استيراد وتصدير ولوجستيات دولية.", rights: "جميع الحقوق محفوظة.", admin: "المنطقة الإدارية", top: "أعلى الصفحة" },
};
export default ar;
